import { dbAdd, dbDelete, dbGetAll, dbGetById, dbPut } from '../indexedDb.ts';

export interface LocalKeyResult {
  id: number;
  objective_id: number;
  title: string;
  target_value: number;
  unit: string;
  status: 'active' | 'archived';
  created_at: string;
  updated_at?: string;
  server_id?: number;
  last_synced_at?: string;
  needs_sync?: boolean;
}

export function listKeyResults() {
  return dbGetAll<LocalKeyResult>('okr_key_results');
}

export async function listKeyResultsByObjective(objectiveId: number) {
  const all = await listKeyResults();
  return all.filter((kr) => kr.objective_id === objectiveId);
}

export function getKeyResultById(id: number) {
  return dbGetById<LocalKeyResult>('okr_key_results', id);
}

export async function getKeyResultByServerId(serverId: number) {
  const all = await listKeyResults();
  return all.find((item) => item.server_id === serverId);
}

export async function createKeyResult(
  data: Omit<LocalKeyResult, 'id' | 'created_at' | 'updated_at' | 'server_id' | 'last_synced_at' | 'needs_sync'>
) {
  const now = new Date().toISOString();
  return dbAdd('okr_key_results', { ...data, created_at: now, needs_sync: true } as any);
}

export async function updateKeyResult(id: number, data: Partial<LocalKeyResult>) {
  const current = await dbGetById<LocalKeyResult>('okr_key_results', id);
  if (!current) throw new Error('Key Result not found');
  const updated = {
    ...current,
    ...data,
    id,
    updated_at: data.updated_at ?? new Date().toISOString(),
    needs_sync: data.needs_sync ?? true,
  };
  await dbPut('okr_key_results', updated);
  return updated;
}

export function removeKeyResult(id: number) {
  return dbDelete('okr_key_results', id);
}

export async function getKeyResultsNeedingSync(): Promise<LocalKeyResult[]> {
  const all = await listKeyResults();
  return all.filter((kr) => kr.needs_sync === true);
}

export async function markKeyResultSynced(id: number, serverId: number) {
  const current = await dbGetById<LocalKeyResult>('okr_key_results', id);
  if (!current) throw new Error('Key Result not found');
  current.server_id = serverId;
  current.last_synced_at = new Date().toISOString();
  current.needs_sync = false;
  await dbPut('okr_key_results', current);
  return current;
}
